import { camelizeKeys } from 'humps';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';

import {
  STORE_SELECTED_TREK,
  SCHEMA_REMOVE_BATCH,
  RESET_SELECTED_TREK,
  STORE_CHILD_TREKS,
} from './types';

export const getSelectedTrekById = trekId => {
  return async (dispatch, getState, api) => {
    dispatch(resetSelectedTrek());
    try {
      const { data } = await api.getTrekById(trekId);
      const albums = await getSelectedTrekAlbums(trekId);
      dispatch(storeSelectedTrek({ ...data, albums }));
    } catch (e) {
      console.log('error while geting trek', e);
    }
  };
};

export const refreshDayData = () => {
  return {
    type: SCHEMA_REMOVE_BATCH,
    payload: {
      schema: 'days',
    },
  };
};

export const storeSelectedTrek = trek => {
  return {
    type: STORE_SELECTED_TREK,
    trek,
  };
};

export const storeChildTreks = childTreks => ({
  type: STORE_CHILD_TREKS,
  childTreks,
});

export const fetchChildTreks = trekId => async dispatch => {
  try {
    const { getForkedTreks } = endpoints.treks;
    const { data } = await api.get(getForkedTreks(trekId));

    dispatch(storeChildTreks(camelizeKeys(data)));
  } catch (err) {
    console.log(err);
  }
};

export const getSelectedTrekAlbums = async trekId => {
  try {
    const { data } = await api.get(endpoints.treks.trekCoverImages(trekId));
    return data;
  } catch (e) {
    console.log('Could not fetch Albums');
    return {};
  }
};

export const resetSelectedTrek = () => ({ type: RESET_SELECTED_TREK });



// WEBPACK FOOTER //
// ./src/redux/actions/selectedTrekActions.js